module.exports = __webpack_public_path__ + "media/product/item-1-19059680.png";